import { Outlet, createRootRouteWithContext } from '@tanstack/react-router';
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools';
import { QueryClient } from 'react-query';
import { authnClient } from '@frontend/auth';
import { PortalUser, getUser } from '@frontend/auth-helpers';
import NotFound from '../../components/NotFound/NotFound';
import ScrollToTop from '../../components/ScrollToTop/ScrollToTop';

const Root = () => {
  return (
    <div>
      <Outlet />
      <ScrollToTop />
      <TanStackRouterDevtools />
    </div>
  );
};

export const Route = createRootRouteWithContext<{
  auth: typeof authnClient;
  queryClient: QueryClient;
  user: PortalUser | undefined;
}>()({
  component: Root,
  notFoundComponent: () => <NotFound />,
  beforeLoad: () => {
    const storedUser = getUser();
    const user =
      authnClient.isUserAuthenticated() && storedUser && authnClient.storedUserIsLoggedInUser()
        ? storedUser
        : undefined;
    return { user };
  },
});
